import React from 'react'

// Icons
import DeleteIcon from '@mui/icons-material/DeleteOutline'
import LoadingBackdrop from '../../../Common/Loading/LoadingBackdrop'
import { IconButton, Tooltip } from '@mui/material'
import useConfirmationAlert from '../../../../hooks/componentHooks/useConfirmationAlert'

import useArchivedTask from '../../../../hooks/taskHooks/useArchiveTask'

import { useSelector } from 'react-redux'
import { RootState } from '../../../../redux/store'

interface TaskArchiveModalProps {
  id: number
}

const TaskArchiveModal: React.FC<TaskArchiveModalProps> = ({ id }) => {
  const { archiveTask, loading } = useArchivedTask({ id })
  const { ConfirmationAlert, openConfirmationAlert } = useConfirmationAlert()

  const role = useSelector((state: RootState) => state.auth.userRole)

  const handleArchiveTask = () => {
    openConfirmationAlert({
      title: 'Archive task',
      text: 'Are you sure you want to archive this task?',
      onConfirm: async () => {
        await archiveTask()
      },
    })
  }

  return (
    <React.Fragment>
      {role !== 'teamMember' ? (
        <Tooltip title='Archive' arrow>
          <IconButton
            id='archive-task-button'
            aria-label='archive'
            color='error'
            size='small'
            onClick={handleArchiveTask}
          >
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      ) : (
        ''
      )}
      {loading && <LoadingBackdrop message={'Archiving task...'} />}
      {ConfirmationAlert}
    </React.Fragment>
  )
}

export default TaskArchiveModal
